import { MatchTeamPlayerPanel as MatchTeamPlayerPanelComponent } from './MatchTeamPlayerPanel.component';
import { connector } from './MatchTeamPlayerPanel.connector';

export const MatchTeamPlayerPanel = connector(MatchTeamPlayerPanelComponent);
